import * as React from "react";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
// import ReactExport from "react-data-export";
import ReactExport from "react-export-excel-fixed-xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimesCircle,
    faPlusCircle,
    faList,
    faFileExcel,
    faFileImport,
    faColumns,
    faDownload,
    faTrashAlt,
    faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { MenuRender } from "../../Shared/GridComponents/CommonComponents";
import { ReqStatus } from "../../Shared/AppConstants";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const userObj = JSON.parse(localStorage.getItem("user"));

export const ExportExcel = () => {
    return (
    <div className="pb-1 pt-1 w-100 myorderGlobalicons">
                <FontAwesomeIcon icon={faFileExcel} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Export to Excel{" "}
            </div>
    );
};

export const Columns = () => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons">
            <FontAwesomeIcon icon={faColumns} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Columns{" "}
        </div>
    );
};

export const Import = () => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons">
            <FontAwesomeIcon icon={faFileImport} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Import{" "}
        </div>
    );
};

export const DownloadTemplate = () => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons">
            <FontAwesomeIcon icon={faDownload} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Download Template{" "}
        </div>
    );
};

export const ActiveSelected = () => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons">
            <FontAwesomeIcon icon={faCheckCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Active Selected{" "}
        </div>
    );
};

export const InActiveSelected = (InActive) => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick = {InActive}>
            <FontAwesomeIcon icon={faTimesCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> In-Active Selected{" "}
        </div>
    );
};

export const RemoveSelected = (Remove) => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick = {Remove}>
            <FontAwesomeIcon icon={faTrashAlt} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Remove Selected{" "}
        </div>
    );
};

export const AddNewJobCategory = (Add) => {
    return (
        <div className="pb-1 pt-1 w-100 myorderGlobalicons" onClick = {Add}>
            
            <FontAwesomeIcon icon={faPlusCircle} className={"nonactive-icon-color ml-2 mr-2"}></FontAwesomeIcon> Add Job Category{" "}
        </div>
    );
};

export const CustomMenu = (excelData , Add, Remove, InActive) => {
    return (
        <Menu openOnClick={true} className="actionItemMenu actionItemMenuThreeDots">
            <MenuItem render={MenuRender}>
                <MenuItem render={() => AddNewJobCategory(Add)} />
                <MenuItem render={Import} disabled/>
                <MenuItem render={DownloadTemplate} disabled />
                <MenuItem render={ActiveSelected} disabled/>
                <MenuItem render={() => InActiveSelected(InActive)} />
                <MenuItem render={() => RemoveSelected(Remove)}/>
                <MenuItem render={ExportExcel} disabled/>
                <MenuItem render={Columns} disabled/>
            </MenuItem>
        </Menu>
    );
};


export function DefaultActions(props) {
    const { dataItem } = props;
    var defaultActions = [
        {
            action: "InActive Job Category",
            controllerName: "Requisition",
            methodName: "GetRequisition",
            nextState: "",
            icon: "faTimesCircle",
            cssStyle: { display: dataItem.status != ReqStatus.DRAFT ? "block" : "none" },
        },
        {
            action: "Edit",
            controllerName: "Requisition",
            methodName: "DuplicateRequisition", 
            nextState: "",
            icon: "faPencilAlt",
        },
        {
            action: "Remove",
            controllerName: "Requisition",
            methodName: "GetRequisition",
            nextState: "",
            icon: "faTrashAlt",
            cssStyle: { display: dataItem.status != ReqStatus.DRAFT ? "block" : "none" },
        },
    ];
    return defaultActions;
}

export class DetailColumnCell extends React.Component<{ dataItem: any; expandChange: any }> {
    render() {
        let dataItem = this.props.dataItem;
        return (
            <td contextMenu="View More" style={{ textAlign: "center" }}>
                <FontAwesomeIcon
                    icon={faList}
                    style={{ marginLeft: "0px!important", marginTop: "0", fontSize: "16px" }}
                    className={"active-icon-blue left-margin cursorPointer"}
                    onClick={() => this.props.expandChange(dataItem)}
                />
            </td>
        );
    }
}
